import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'day_diff'
})
export class Day_diffPipe implements PipeTransform {
  constructor(private _translateService: TranslateService) {}

  transform(value: Date): string {
    const currentDate = new Date();
    const diffMilliseconds = currentDate.getTime() - value.getTime();
    const diffMinutes = Math.floor(diffMilliseconds / (1000 * 60));
    const diffHours = Math.floor(diffMinutes / 60);

    if (diffHours >= 24) {
      const days = Math.floor(diffHours / 24);
      return `${days} ${this.getTranslation(days, 'day', 'days')}`;
    } else if (diffHours >= 1) {
      return `${diffHours} ${this.getTranslation(diffHours, 'hour', 'hours')}`;
    } else {
      return this._translateService.instant('while');
    }
  }

  private getTranslation(value: number, singularKey: string, pluralKey: string): string {
    return value === 1 ? this._translateService.instant(singularKey) : this._translateService.instant(pluralKey);
  }
}